
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import {
  GetKnowledgeList,
  GetKnowledgeDetail,
  DelKnowledge,
  EditKnowledge,
  GetZidian,
} from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends mixins(listMixin) {
  private data: any[] = [];
  private jigous: any[] = [];
  private H: any = "";
  private ifShowEdit: any = false;
  private editData: any = {};
  private forceUpdate() {
    this.$forceUpdate();
  }
  private chuchus: any = [];
  private types: any = [];
  private tuijians: any = [];
  private levels: any = [];
  private getType(type: any, key: any) {
    const params: any = {
      data_type: type,
    };
    GetZidian(this, params).then((res: any) => {
      this[key] = res[type];
    });
  }
  private openEdit(item?: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
    } else {
      this.editData = {};
    }
    this.ifShowEdit = true;
  }
  private editSure() {
    if (!this.editData["干预内容"]) {
      this.$message.warning("请输入干预内容！");
      return;
    }
    if (!this.editData["类别"]) {
      this.$message.warning("请选择类别！");
      return;
    }
    if (!this.editData["推荐类别"]) {
      this.$message.warning("请选择推荐类别！");
      return;
    }
    if (!this.editData["证据级别"]) {
      this.$message.warning("请选择证据级别！");
      return;
    }
    if (!this.editData["文献出处"]) {
      this.$message.warning("请选择文献出处！");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      knowledge_base_id: this.editData.knowledge_base_id,
      知识库类型: "干预库",
      类别: this.editData["类别"],
      干预内容: this.editData["干预内容"],
      推荐类别: this.editData["推荐类别"],
      证据级别: this.editData["证据级别"],
      文献出处: this.editData["文献出处"],
    };
    EditKnowledge(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(this.editData.id ? "编辑" : "新增" + "成功");
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 获取干预库列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      知识库类型: "干预库",
      类别: this.filters["类别"],
      文献出处: this.filters["文献出处"],
      干预内容: this.filters.search,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("ganyukuFilter", JSON.stringify(this.filters));
    GetKnowledgeList(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.data = res.datas.datas;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  /**
   * @description 删除
   */
  private deleteOne(item: any) {
    this.$confirm("确定删除该条记录么？", "删除", {
      customClass: "commonConfirm",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          params: {
            knowledge_base_id: item.knowledge_base_id,
          },
        };
        DelKnowledge(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  mounted() {
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("ganyukuFilter")) {
      this.filters = JSON.parse(localStorage.getItem("ganyukuFilter") as any);
    }
    this.getList();
  }
}
